import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from "react-router-dom";
import CustomDivider from "../../components/extras/CustomDivider";
import localDB from "../../data/localDB";
import {
    Breadcrumb,
    Button,
    Card,
    Checkbox,
    Form,
    Grid,
    Icon,
    List,
    Message,
    Modal,
    Popup,
    Statistic
} from "semantic-ui-react";
import ClientData from "../../data/ClientData";
import {FormattedNumber} from "react-intl";
import DynamicTable from "../../components/extras/DynamicTable";
import SaleTotal from "../../components/sales/SaleTotal";
import SaleState from "../../components/sales/SaleState";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import {showToast} from "../../actions/ToastAction";
import {dynamicTableList} from "../../actions/DynamicTableDataAction";
import connect from "react-redux/lib/connect/connect";
import update from "react-addons-update";
import resources from "../../data/resources";
import c from "../../constants";

const moneyMask = createNumberMask({
    prefix: '$',
});

class Client extends Component {

    constructor(props){
        super(props);

        let other_actions_components =[
            this.buttonPayDebt,
            this.buttonSendEmailPayDebt
        ]

        this.state = {
            client: localDB.get('current_client'),
            client_form: localDB.get('current_client'),
            summary: {},
            loading_summary: true,
            products: {
                headers: ['Producto', 'Cantidad'],
                name: 'Producto',
                title: 'Productos Consumidos',
                pagination: true,
                url: `clients/${props.match.params.id}/products`,
                values: ['id', 'name', 'total'],
                id: 'client_products'
            },
            sales: {
                headers: ['Nº', 'Fecha', 'Sucursal', 'Total', 'Estado', 'Acciones'],
                name: 'Compra',
                title: 'Compras',
                has_actions: true,
                pagination: true,
                navigate: true,
                search: {active:true},
                url: `client/${props.match.params.id}/sales`,
                values: ['id', 'billing_number', 'date', 'branch_office', 'total', 'state'],
                child_fields: [{branch_office:'name'}],
                component_fields: [{ total: SaleTotal, state: SaleState}],
                datetime_fields: ['date'],
                search_fields: [
                    {id:'billing_number', name:'Nº Orden', type:'text', is_main:true},
                    {id:'state', name:'estado', type:'list', values:[
                        {'text': 'Pendiente', value:1},
                            {'text': 'Anulado', value:2},
                            {'text': 'Pagado', value:3},
                            {'text': 'Ver todo', value:''},
                        ], is_main:false},
                ],
                other_actions_components: other_actions_components,
                id: 'table_sale_history',
                pay_debt_error: false
            },
            modal_pay_debt: false,
            pay_debt: 0,
            type_payment: 1,
            modal_send_email: false,
            saving_pay_debt: false,
            full_name_error: false,
            email_error: false,
            sending_email_pay_debt: false,
            update_client_data: true
        }
        this.toggleModalPayDebt = this.toggleModalPayDebt.bind(this)
        this.toggleModalSendEmail = this.toggleModalSendEmail.bind(this)
        this.handlePayDebtChange = this.handlePayDebtChange.bind(this);
        this.sales_dynamic_table = React.createRef();
    }

    buttonPayDebt = () => {
        if(this.state.summary.outstanding_balance > 0){
            return <div style={{margin:6}}>
                <Button fluid content='Pagar saldo pendiente' onClick={()=> this.toggleModalPayDebt()}/>
            </div>;
        }
    }

    buttonSendEmailPayDebt = () => {
        if(this.state.summary.outstanding_balance > 0){
            return <div style={{margin:6}}>
                <Button fluid content='Enviar cuenta de cobro por email' onClick={()=> this.toggleModalSendEmail()}/>
            </div>;
        }
    }

    handlePayDebtChange = (event) => {
        let pay_debt = isNaN(parseFloat(event.target.value.replace(/\D/g, ''))) ? '':parseFloat(event.target.value.replace(/\D/g, ''));
        this.setState({pay_debt});
        if (event.target.value.trim() === '') {
            this.setState({pay_debt_error: true})
        }else if(pay_debt > this.state.summary.outstanding_balance){
            this.setState({pay_debt_error: true})
        } else {
            this.setState({pay_debt_error: false})
        }
    };

    toggleUpdateClientData = () => this.setState(() => ({ update_client_data: !this.state.update_client_data }))

    componentWillMount(){
        ClientData.summary(this.state.client.id).then(summary =>{
            this.setState({summary, loading_summary:false});
        }).catch((error) => {console.log(error)});
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'navigate'){
            localDB.saveSaleStorage(response.data, 'history');
            this.props.history.push(`/sale/view/${response.data.billing_number}`);
        }
    };

    toggleModalPayDebt = () => {
        this.setState({modal_pay_debt: !this.state.modal_pay_debt})
    }

    toggleModalSendEmail = () => {
        this.setState({modal_send_email: !this.state.modal_send_email})
    }

    sendEmailPayDebt = () => {
        this.setState({sending_email_pay_debt: true})
        if(this.state.client_form.full_name.trim() === ''){
            this.setState({full_name_error: true})
        }else if( this.state.client_form.email.trim() === ''){
            this.setState({email_error: true})
        } else if (!this.state.email_error && !this.state.full_name_error){
            let data = {
                full_name: this.state.client_form.full_name,
                client_id: this.state.client_form.id,
                email: this.state.client_form.email,
                update_data: this.state.update_client_data
            }
            ClientData.send_email_pay_debt(data, (res) => {
                if (res.send) {
                    this.setState({client: res.data, client_form: res.data})
                    this.props.showToast({message: res.message, type: 'success'});
                } else {
                    this.props.showToast({message: res.message, type: 'error'});
                }
            }).finally(() =>{
                this.toggleModalSendEmail()
                this.setState({sending_email_pay_debt: false})
            })
        }
    }


    makePayDebt = () => {
        if(this.state.pay_debt <= 0){
            this.setState({pay_debt_error: true})
        }else if(!this.state.pay_debt_error){
            this.setState({saving_pay_debt: true})
            let data = {
                client: this.state.client.id,
                pay_debt: this.state.pay_debt,
                type: this.state.type_payment
            }

            ClientData.pay_debt(data, (res) => {
                if (res.update) {
                    this.setState({summary: res.summary})
                    this.props.dynamicTableList({'refresh': true})
                } else {
                    this.props.showToast({message: res.message, type: 'error'});
                }
            }).finally(() =>{
                this.toggleModalPayDebt()
                this.setState({pay_debt: 0, saving_pay_debt: false})
            })
        }
    }

    handleFullNameChange = (event) => {
        let full_name = update(this.state, {
            client_form: {
                full_name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(full_name);
        if (event.target.value.trim() === '') {
            this.setState({full_name_error: true})
        } else {
            this.setState({full_name_error: false});
        }
    };

    handleEmailChange = (event) => {
        let email = update(this.state, {
            client_form: {
                email: {
                    $set: event.target.value.toLowerCase().trim()
                }
            }
        });
        this.setState(email);
        if (event.target.value.trim() !== '') {
            if (resources.validators.isValidEmailAddress(event.target.value)) {
                this.setState({email_error: false})
            } else {
                this.setState({email_error: true})
            }
        } else {
            this.setState({email_error: false})
        }
    };


    handlePaymentTypeChange = (result) => {
        this.setState({type_payment: result});
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Cliente - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/reports'>Informes</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section as={Link} to='/reports/clients'>Clientes</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>{this.state.client.full_name}</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Card.Group stackable centered>
                    <Card>
                        <Card.Content>
                            <Card.Header>Información Personal</Card.Header>
                            <Card.Description>
                                <List>
                                    <List.Item>
                                        <List.Icon name='user outline' />
                                        <List.Content>{this.state.client.full_name ? this.state.client.full_name:'-'}</List.Content>
                                    </List.Item>
                                    <List.Item>
                                        <List.Icon name='id card outline' />
                                        <List.Content>{this.state.client.identification ? this.state.client.identification:'-'}</List.Content>
                                    </List.Item>
                                    <List.Item>
                                        <List.Icon name='gift' />
                                        <List.Content>
                                            <List.Content>{this.state.client.birthdate ? this.state.client.birthdate:'-'}</List.Content>
                                        </List.Content>
                                    </List.Item>
                                </List>
                            </Card.Description>
                        </Card.Content>
                    </Card>
                    <Card>
                        <Card.Content>
                            <Card.Header>Información de Contacto</Card.Header>
                            <Card.Description>
                                <List>
                                    <List.Item>
                                        <List.Icon name='map marker alternate' />
                                        <List.Content>{this.state.client.address ? this.state.client.address:'-'}</List.Content>
                                    </List.Item>
                                    <List.Item>
                                        <List.Icon name='phone' />
                                        <List.Content>{this.state.client.phone ? this.state.client.phone:'-'}</List.Content>
                                    </List.Item>
                                    <List.Item>
                                        <List.Icon name='mail' />
                                        <List.Content>
                                            <List.Content>{this.state.client.email ? this.state.client.email:'-'}</List.Content>
                                        </List.Content>
                                    </List.Item>
                                </List>
                            </Card.Description>
                        </Card.Content>
                    </Card>
                </Card.Group>
                <CustomDivider/>
                <Statistic.Group size='tiny' className='center-div'>
                    <Statistic>
                        {this.state.loading_summary ? <Icon loading name='spinner' />:
                            <Statistic.Value>
                                $<FormattedNumber value={this.state.summary.total_sales} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                            </Statistic.Value>
                        }
                        <Statistic.Label>En Compras</Statistic.Label>
                    </Statistic>
                    <Statistic>
                        {this.state.loading_summary ? <Icon loading name='spinner' />:
                            <Statistic.Value>
                                $<FormattedNumber value={this.state.summary.discounts} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                            </Statistic.Value>}
                        <Statistic.Label>En descuentos</Statistic.Label>
                    </Statistic>
                    <Statistic>
                        {this.state.loading_summary ? <Icon loading name='spinner' />:
                            <Statistic.Value className={this.state.summary.outstanding_balance > 0 ? 'orange':null}>
                                $<FormattedNumber value={this.state.summary.outstanding_balance } currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                            </Statistic.Value>
                        }
                        <Statistic.Label>Saldo Pendiente</Statistic.Label>
                    </Statistic>
                    <Statistic>
                        {this.state.loading_summary ? <Icon loading name='spinner' />:
                            <Statistic.Value>
                                <FormattedNumber value={this.state.summary.total_products} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                            </Statistic.Value>
                        }
                        <Statistic.Label>Productos Comprados</Statistic.Label>
                    </Statistic>
                </Statistic.Group>
                <CustomDivider/>
                <Grid>
                    <Grid.Row>
                        <Grid.Column style={{marginBottom:'3em'}}>
                            <DynamicTable {...this.state.sales} callbackDynamicTable={this.callbackDynamicTable} ref={this.sales_dynamic_table}/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column style={{marginBottom:'3em'}}>
                            <DynamicTable {...this.state.products} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Modal open={this.state.modal_pay_debt} dimmer='inverted' size='tiny' onClose={this.toggleModalPayDebt}>
                    <Modal.Header>Pagar saldo pendiente</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Message>
                                <Message.Header>
                                    Advertencia
                                </Message.Header>
                                <p>
                                    Si tienes muchas ventas con saldos pendientes, este valor se agregará a los pagos y cerrará las ventas
                                    <Popup
                                        trigger={<Icon name='help' />}
                                        content='Ejemplo si tienes 3 ventas y cada una de ellas tienes un saldo pendiente de $10.000 para un total de $30.000 de saldo pendiente
                                    y haces un pago por $25.000 las dos primeras ventas se les agregarán los saldos pendientes o sea se les agregará $10.000 a cada uno y se cerrarán y la tercar venta se agregará un
                                    pago por $5.000 y quedará abierta.'
                                        size='small'
                                    />
                                </p>
                            </Message>
                            <Form>
                                <Form.Input
                                    label='Valor a pagar'
                                    name={'pay_debt'}
                                    error={this.state.pay_debt_error}
                                    children={
                                        <MaskedInput
                                            mask={moneyMask}
                                            name='pay_debt'
                                            value={this.state.pay_debt}
                                            placeholder='Valor a Pagar'
                                            onChange={this.handlePayDebtChange}
                                        />
                                    }
                                />
                                <Form.Select placeholder='Forma de Pago' label='Forma de Pago'
                                             options={c.PAYMENT_TYPES} value={this.state.type_payment}
                                             onChange={(e, {value}) => this.handlePaymentTypeChange(value)}/>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.toggleModalPayDebt} content="Cancelar"/>
                        <Button primary icon='save' color='primary' loading={this.state.saving_pay_debt} disabled={this.state.saving_pay_debt} labelPosition='left' onClick={this.makePayDebt} content="Pagar"/>
                    </Modal.Actions>
                </Modal>

                <Modal open={this.state.modal_send_email} dimmer='inverted' size='tiny' onClose={this.toggleModalSendEmail}>
                    <Modal.Header>Enviar cuenta de cobro</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form>
                                <Form.Input label='Cliente' placeholder='Cliente' required
                                            value={this.state.client_form.full_name}
                                            onChange={this.handleFullNameChange}
                                            error={this.state.full_name_error}/>
                                <Form.Input label='Correo Electrónico' placeholder='Correo Electrónico'
                                            value={this.state.client_form.email}
                                            error={this.state.email_error}
                                            onChange={this.handleEmailChange}/>
                                <Form.Field>
                                    <Checkbox label='Actualizar la información del cliente' checked={this.state.update_client_data} onChange={this.toggleUpdateClientData}/>
                                </Form.Field>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.toggleModalSendEmail} content="Cancelar"/>
                        <Button primary icon='save' color='primary' loading={this.state.sending_email_pay_debt} disabled={this.state.sending_email_pay_debt} labelPosition='left' onClick={this.sendEmailPayDebt} content="Enviar"/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(alert) {
            dispatch(showToast(alert));
        },
        dynamicTableList(data){
            dispatch(dynamicTableList(data))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(Client)



// WEBPACK FOOTER //
// ./src/containers/contacts/Client.js